import ajax from './index'
import apiEnv from './apiEnv'
// 获取渠道列表
export function getLogin(data) {
  return ajax.post(`${apiEnv.api1}/api/ExamManage/ExamLogin`, data)
}


//搜索用户,从mongo
export function searchUsersFromMongo(data) {
  return ajax.post(`${apiEnv.api4}/api/User/SearchUsersFromMongo`, data)
}